import { FC } from 'react'
import { useUser } from '@clerk/clerk-react'
import './group-card-create.css'

// COMPONENTS
import PaymentMethodBrand from '@components/atoms/payment-method-brand'

// TYPES
import type { GroupState } from '../../../routes/group/_localStore/reducer'

// UTILITIES
import { flatten } from '@utils/string-helper'
import { priceFormatter } from '@utils/number-helper'
import { useMemo } from 'react'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    groupState: GroupState
    lastFour?: string
}

const GroupCardCreate: FC<Props> = (props) => {
    const { className: classProps, groupState, lastFour, ...divProps } = props
    const { user } = useUser()
    const className = flatten("group-card-create", classProps)
    const NoC = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() // Name on Card
    const { pledgeAmount } = groupState

    // Default: current month / current year + 3
    const expirationDisplay = useMemo(() => {
        const now = new Date()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const year = String(now.getFullYear() + 3).slice(-2)
        return `${month}/${year}`
    }, [])

    return (
        <div className={className} {...divProps}>
            <div className='flex flex-row items-start justify-between'>
                <div className='flexcolumn gap-2'>
                    <div className='flex flex-row items-center gap-2'>
                        <img className='splitcard' src="/splitcard/logo/white-and-blue-fallback.png" alt="Splitcard Logo" />
                        <p className="text-body highlight">Banking Partners:</p>
                    </div>
                    <div className='flex flex-row items-center gap-2' >
                        <img className="corpay select-none" src="/corpay-logo.svg" draggable="false" />
                        <p>&</p>
                        <img className="tera select-none" src="/tera/name.svg" draggable="false" />
                    </div>
                </div>
                <div className='flex flex-col items-end'>
                    <p className='text-body-2 select-none text-gray-500'>Available</p>
                    <h1 style={{ fontSize: '2rem' }}>{priceFormatter.format(pledgeAmount || 0)}</h1>
                </div>
            </div>
            <div className="card-number-container flex flex-row items-center">
                <div className="card-mask">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="card-mask-group">
                            <div className="card-mask-dot" />
                            <div className="card-mask-dot" />
                            <div className="card-mask-dot" />
                            <div className="card-mask-dot" />
                        </div>
                    ))}
                    <p className="text-body select-none" style={{ fontSize: '1.5rem', marginLeft: '0.25rem' }}>{lastFour || 'XXXX'}</p>
                </div>
                <p className="text-body select-none">{expirationDisplay}</p>
            </div>
            <div className="flex flex-row items-center justify-between">
                {!!NoC && <h2 style={{ fontSize: '1.1rem' }}>{NoC}</h2>}
                <PaymentMethodBrand className='mastercard-icon' height='2rem' width='3rem' brand="mastercard-icon" draggable="false" />
            </div>
        </div>
    )
}

export default GroupCardCreate
